
import React, { Component } from 'react'
import './Product.scss'

class Product extends Component {

  render() {
    return (
      <div id="product" className="proCon">
        <h1><img src={require('./images/product.png')}/> </h1>
        <ul>
          <li>
            <p className="img img_1"></p>
            <p className="title">智能获客</p>
            <p className="desc">我们能为合作机构提供涵盖多元化获客矩阵、精准流量触达、精细化营销管理的智能获客解决方案。</p>
            <a className="href" href="./services/huoke">查看详情</a>
          </li>
          <li>
            <p className="img img_2"></p>
            <p className="title">智能风控</p>
            <p className="desc">中腾信智能风控系统集人工智能技术与业务思考于一身，贯穿消费信贷风控全流程，涵盖反欺诈平台、智能决策引擎、变量计算平台、征信平台、信贷审批系统5大产品。</p>
            <a className="href" href="./services/fengkong">查看详情</a>
          </li>
          <li>
            <p className="img img_3"></p>
            <p className="title">智能机器人</p>
            <p className="desc">为金融、教育、招聘、互联网等行业量身定制，提供AI电话外呼，意向客户精确筛选，解决客户难题。</p>
            <a className="href" href="./services/jiqiren">查看详情</a>
          </li>
        </ul>
        <ul>
          <li>
            <p className="img img_4"></p>
            <p className="title">自动建模平台</p>
            <p className="desc">通过自动建模平台，降低建模人员技术门槛与建模过程中的人工参与量，提升建模效率，为客户快速挖掘数据价值提供帮助。</p>
            <a className="href" href="./services/automl">查看详情</a>
          </li>
          <li>
            <p className="img img_5"></p>
            <p className="title">一站式信贷解决方案</p>
            <p className="desc">语雀是一款优雅高效的在线文档编辑与协同工具， 让每个企业轻松拥有文档中心阿里巴语雀是一款优雅高效的在线</p>
            <a className="href" href="./services/fangan">查看详情</a>
          </li>
          <li className="proLast">
            <p className="img img_6"></p>
            <p className="title">敬请期待</p>
            <p className="desc">更多优秀产品将会与您见面</p>
          </li>
        </ul>
      </div>
    )
  }
}

export { Product }



// WEBPACK FOOTER //
// ./modules/home/Product.js